import type { TFunction } from "i18next";
import type { Language } from "../assets/languages/langs";

type ReasonName = Partial<Record<Language, string | null>>;

interface ClosedOrderComment {
	status?: string;
	subStatus?: string;
	clientRefusalReason?: { id: number; name: ReasonName } | null;
}

/** Причины из старой модалки: у заказов, закрытых до появления справочника. */
const LEGACY_REASONS = ["too_expensive", "client_did_not_choose_car"];

/** Название на нужном языке, иначе первое заполненное. */
export const getClientRefusalReasonName = (
	name: ReasonName | null | undefined,
	language: Language,
): string => name?.[language] || Object.values(name ?? {}).find(Boolean) || "";

/** Причина отказа клиента в закрытом заказе. */
export const getClosedOrderClientRefusalReason = (
	comment: ClosedOrderComment | null | undefined,
	language: Language,
	t: TFunction,
): string => {
	if (comment?.clientRefusalReason) {
		return getClientRefusalReasonName(
			comment.clientRefusalReason.name,
			language,
		);
	}

	return comment?.subStatus && LEGACY_REASONS.includes(comment.subStatus)
		? t(`order_closed_status.${comment.subStatus}`)
		: "";
};

/** Уточнение к статусу закрытия: причина отказа либо перевод подстатуса. */
export const getClosedOrderSubReason = (
	comment: ClosedOrderComment | null | undefined,
	language: Language,
	t: TFunction,
): string => {
	if (comment?.clientRefusalReason) {
		return getClientRefusalReasonName(
			comment.clientRefusalReason.name,
			language,
		);
	}

	return comment?.subStatus
		? t(`order_closed_status.${comment.subStatus}`)
		: "";
};
